import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { PhxIamPolicyMultiSelect as IamPolicyMultiSelectBase } from 'config-editor';
import { useMemo } from 'react';

type Props = FieldExtensionComponentProps<string[]>;

/**
 * Scaffolder field extension wrapper for IamPolicyMultiSelect.
 * Adapts the shared IamPolicyMultiSelect component to work with Backstage scaffolder field extensions.
 */
export const IamPolicyMultiSelect = (props: Props) => {
  const { onChange, schema, uiSchema, formData } = props;
  const title = schema.title || uiSchema?.['ui:title'] || 'IAM Policies';
  const description =
    schema.description || uiSchema?.['ui:description'] || 'Select one or more IAM policies';

  // Ensure formData is an array
  const value = useMemo(() => {
    if (!formData || !Array.isArray(formData)) {
      return [];
    }
    return formData;
  }, [formData]);

  return (
    <IamPolicyMultiSelectBase
      value={value}
      onChange={onChange}
      label={title}
      helperText={description}
      variant="standard"
    />
  );
};

// Field extension registration moved to plugin.ts following Backstage best practices
